import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=5cc73a87&scoped=true&"
import script from "./Usage.vue?vue&type=script&lang=ts&"
export * from "./Usage.vue?vue&type=script&lang=ts&"
import style0 from "./Usage.vue?vue&type=style&index=0&id=5cc73a87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc73a87",
  null
  
)

export default component.exports